module.exports = __webpack_public_path__ + "img/1.dda8cd90.png";